<template>
  <div class="product-kits-bottom">
    <div class="kits-bottom-header">
      <div>
        <h6 class="kits-bottom-header__title">
          {{ messages.kitAmount }}
        </h6>
      </div>
      <div class="kits-bottom-header__prices">
        <div>
          <DefPriceOld>
            {{ result?.kitPrice?.printPriceOld }}
          </DefPriceOld>
          <DefPrice>
            {{ result?.kitPrice?.printPrice }}
          </DefPrice>
        </div>
        <DefSale>
          {{ result?.kitPrice?.printDiscount }}
        </DefSale>
      </div>
    </div>
    <div class="kits-bottom-footer">
      <DefLinkSecondary line="dashed" @click="modal.hide()">
        {{ basketMessages?.continueOrder }}
      </DefLinkSecondary>
      <DefButtonPrimary @click="$emit('saveKits')">
        {{ createOrder?.name }}
      </DefButtonPrimary>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import DefPriceOld from '@components/Def/DefPriceOld/DefPriceOld.vue';
import DefPrice from '@components/Def/DefPrice/DefPrice.vue';
import DefSale from '@components/Def/DefSale/DefSale.vue';
import DefButtonPrimary from '@components/Def/DefButtonPrimary/DefButtonPrimary.vue';
import useModal from '@use/useModal/useModal';
import DefLinkSecondary from '../../Def/DefLink/DefLinkSecondary';

export default {
  name: 'ProductKitsBottom',
  components: {
    DefButtonPrimary,
    DefSale,
    DefPrice,
    DefPriceOld,
    DefLinkSecondary,
  },
  props: ['result', 'kits'],
  data() {
    return {
      modal: useModal(),
    };
  },
  computed: {
    ...mapState({
      basketMessages: ({ basket }) => basket.data.messages,
      createOrder: ({ basket }) => basket.data.routes.createOrder,
      messages: ({ product }) => product?.data?.product?.kits?.messages,
    }),
  },
};
</script>

<style lang="scss" scoped>
.product-kits-bottom {
  border-top: 1px solid rgba(223, 223, 223, 0.6);
  margin-top: 8px;
}
.kits-bottom-header {
  display: flex;
  justify-content: space-between;
  padding: 16px 0;
  &__title {
    font-weight: 500;
    font-size: 14px;
    line-height: 100%;
    color: #191918;
    @include point-md {
      font-size: 18px;
      line-height: 120%;
    }
  }
  :deep(.def-price) {
    font-size: 18px;
    line-height: 110%;
  }
  :deep(.def-price-old) {
    font-size: 14px;
    line-height: 110%;
    margin-right: 16px;
  }
  :deep(.def-sale) {
    display: block;
    font-weight: 500;
    font-size: 14px;
    line-height: 100%;
    color: #618eaf;
    margin-top: 4px;
  }
}
.kits-bottom-footer {
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  //padding-bottom: 24px;
  @include point-md {
    align-items: center;
    flex-direction: row;
  }
  :deep {
    .def-link-secondary {
      font-weight: 500;
      font-size: 12px;
      line-height: 115%;
      letter-spacing: 0.1em;
      text-transform: uppercase;
      color: #618eaf;
      margin-right: 23px;
      text-align: center;
      margin-bottom: 16px;
      @include point-md {
        text-align: start;
        margin-bottom: 0;
      }
    }
  }
}
</style>
